import { Client } from '../../domain/entities/client.entity';
import { ClientName } from '../../domain/value-objects/client-name.vo';
import { NationalIdentityCard } from '../../domain/value-objects/national-identity-card.vo';

export interface ClientApiResponse {
  id: string;
  name: string;
  nationalIdentityCard: string;
  createdAt: string;
  usersCount: number;
}

export interface ClientListPagedApiResponse {
  items: ClientApiResponse[];
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalItemsCount: number;
  orderField?: string;
  ascendingOrder: boolean;
}

export class ClientMapper {
  static toDomain(raw: ClientApiResponse): Client {
    return {
      id: raw.id,
      name: ClientName.create(raw.name),
      nationalIdentityCard: new NationalIdentityCard(raw.nationalIdentityCard),
      usersCount: raw.usersCount,
      createdAt: new Date(raw.createdAt),
      updatedAt: new Date(raw.createdAt),
    };
  }

  static toDomainList(rawList: ClientApiResponse[]): Client[] {
    return rawList.map((raw) => this.toDomain(raw));
  }

  // ─── Presentation → API ──────────────────────────────────────────────────────

  static sortFieldToApi(field: string): string {
    const mapping: Record<string, string> = {
      'id': 'id',
      'name': 'name',
      'nationalIdentityCard': 'nationalidentitycard',
      'createdAt': 'createdat',
    };
    return mapping[field] ?? field.toLowerCase();
  }

  static dateFilterToIso(value: unknown): string {
    const date = value instanceof Date ? value : new Date(value as string);
    return date.toISOString();
  }
}
